import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "../ui/Button/index.js";
import { useTranslation } from "react-i18next";

/**
 * NavigationLinks component that renders the main navigation links.
 * Highlights the current active link based on the location.
 * 
 * @param {Object} props - Component props.
 * @param {Function} props.handleClick - Callback function to handle link clicks.
 */
export default function NavigationLinks({ handleClick }) {
    const location = useLocation();
    const { t } = useTranslation();

    const links = [
        { path: "/", label: t("navigation.home") },
        { path: "/search", label: t("navigation.searchPersona") },
        { path: "/about", label: t("navigation.aboutUs") },
        // { path: "/research", label: "Research" },
        { path: "/partner", label: t("navigation.partnerWithUs") },
    ];

    return (
        <nav className="flex">
            {links.map(({ path, label }) => (
                <div key={path} className="flex flex-col items-center">
                    <Button
                        as={Link}
                        to={path}
                        onClick={handleClick}
                        variant={location.pathname === path ? "navActive" : "nav"}
                        className="px-3"
                    >
                        {label}
                    </Button>
                    {location.pathname === path && (
                        <span className="w-1 h-1 bg-red-600 rounded-full mt-1"></span>
                    )}
                </div>))}
        </nav>
    );
}
